import { Component, forwardRef, OnInit, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-rate',
  templateUrl: './d-rate.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DRateComponent),
      multi: true
    }
  ]
})
export class DRateComponent extends DynamicComponentBase {
  static KEY = 'd-rate';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.value !== 'number') {
      config.value = 3;
    }
  }
}
